import { useCoverage } from "../../../../../packages/coverage/hooks/useCoverage";
import { usePatient } from "../../../../../packages/patients/hooks/usePatient";
import {
  getUsStateName,
  inferRegionCode,
} from "../../../../../packages/costs/estimates";
import { useOnboarding } from "../../../onboarding/OnboardingContext";

export type PrefillData = {
  fullName: string | null;
  dateOfBirth: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  addressLine1: string | null;
  city: string | null;
  country: string | null;
  insuranceCarrier: string | null;
  memberId: string | null;
  groupNumber: string | null;
  employer: string | null;
  treatmentType: string | null;
  state: string | null;
  zipCode: string | null;
};

export function useApplicationPrefill(): PrefillData {
  const { primaryPolicy } = useCoverage();
  const { data: patient } = usePatient();
  const { data: onboardingData } = useOnboarding();
  const holder = primaryPolicy?.policyHolder;
  const patientName = [patient?.firstName, patient?.lastName]
    .filter(Boolean)
    .join(" ");
  const patientAddress = patient?.addresses?.[0];

  const addressParts = [
    patientAddress?.address1,
    patientAddress?.city,
    patientAddress?.postalCode,
  ].filter(Boolean);
  const holderAddressParts = [
    holder?.streetAddress,
    holder?.city,
    holder?.postalCode,
  ].filter(Boolean);

  return {
    fullName: patientName || holder?.fullName || null,
    dateOfBirth: patient?.dateOfBirth ?? holder?.dateOfBirth ?? null,
    email: patient?.email ?? holder?.emailAddress ?? null,
    phone: patient?.phoneNumber ?? holder?.phoneNumber ?? null,
    address:
      addressParts.length > 0
        ? addressParts.join(", ")
        : holderAddressParts.length > 0
          ? holderAddressParts.join(", ")
          : null,
    addressLine1: patientAddress?.address1 ?? holder?.streetAddress ?? null,
    city: patientAddress?.city ?? holder?.city ?? null,
    country: patientAddress?.country ?? null,
    insuranceCarrier: primaryPolicy?.insuranceCarrier ?? null,
    memberId: primaryPolicy?.memberId ?? null,
    groupNumber: primaryPolicy?.groupNumber ?? null,
    employer: primaryPolicy?.employer?.name ?? null,
    treatmentType:
      (patient?.treatments?.[0]?.intent as string | undefined) ??
      onboardingData.treatmentIntent ??
      null,
    state:
      getUsStateName(
        inferRegionCode(
          patient?.addresses?.[0]?.country ?? onboardingData.country,
          patient?.addresses?.[0]?.postalCode ?? onboardingData.zipCode,
        ),
      ) ?? null,
    zipCode: patientAddress?.postalCode ?? onboardingData.zipCode ?? null,
  };
}
